{
  "TemplatingEngineUrl": "https://pon-universe-templateengine.azurewebsites.net",
  "AppInsightsConnectionString": "InstrumentationKey=a63cd15b-5f51-4eeb-8468-d644b4479bab;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=625a67a7-51fd-4447-b1ad-e3a831329eb8",
  "EnableApplicationInsights": true,
  "DapUrl": "https://dap-pon.mendixcloud.com/link/Contract/",
  "FeatureSwitches": {
    "EnableLeaseCompanies": true
  },
  "EnableInactivityTimer": true
}
